const SIDEBAR_SELECTOR = '#filters-sidebar'
const MAIN_SELECTOR = 'main'

const findCollapseTarget = trigger => {
    const selector = trigger.getAttribute('data-target') || trigger.getAttribute('href')

    if (!selector || selector.charAt(0) !== '#') {
        return null
    }

    return document.querySelector(selector)
}

const setCollapseState = (trigger, target, open) => {
    target.classList.toggle('show', open)
    trigger.classList.toggle('collapsed', !open)
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false')
}

const toggleWidget = trigger => {
    const target = findCollapseTarget(trigger)

    if (!target) {
        return
    }

    setCollapseState(trigger, target, !target.classList.contains('show'))
}

const toggleSidebar = () => {
    document.querySelector(MAIN_SELECTOR)?.classList.toggle('sidebar-opened')
}

const closeSidebar = () => {
    document.querySelector(MAIN_SELECTOR)?.classList.remove('sidebar-opened')
}

export const initFilterSidebar = () => {
    if (window.__filterSidebarInitialized) {
        return
    }

    window.__filterSidebarInitialized = true

    document.addEventListener('click', event => {
        const toggle = event.target.closest('.sidebar-toggle')

        if (toggle) {
            event.preventDefault()
            event.stopPropagation()
            event.stopImmediatePropagation()
            toggleSidebar()
            return
        }

        if (event.target.closest('.sidebar-overlay')) {
            event.preventDefault()
            event.stopPropagation()
            event.stopImmediatePropagation()
            closeSidebar()
            return
        }

        const trigger = event.target.closest(`${SIDEBAR_SELECTOR} .widget-title [data-toggle="collapse"]`)

        if (!trigger) {
            return
        }

        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        toggleWidget(trigger)
    }, true)
}
